import { cn } from "@omni/utils/styles";

import { LogoutLinkContainer } from "@/components/Account/LogoutLink/logoutLink.container";
import { Divider } from "@/components/General/Divider/divider.component";
import { PageLinks } from "@/components/General/PageLinks/pageLinks.component";
import { useAccountButtonContext } from "@/components/Navigation/Buttons/AccountButton/context/accountButton.context";

export const Content = () => {
    const { links } = useAccountButtonContext();

    if (!links?.length) return null;

    return (
        <div className={cn("tw:text-base")}>
            <Divider className={cn("tw:mb-4")} />
            <div className={cn("tw:mx-2")}>
                <PageLinks links={links} />
            </div>
            <Divider className={cn("tw:mb-2")} />
            <div className={cn("tw:mx-2")}>
                <LogoutLinkContainer className={cn("tw:no-underline!")} />
            </div>
        </div>
    );
};
